import React, { ReactElement } from 'react';
import { Flex, Box } from 'reflexbox';
import styled from '@emotion/styled';
import { MARKETING_PAGE_BREAKPOINT_TABLET } from '../../Style/breakpoints';
import { JoinOpenLearningProps } from './types';
import { Button } from '../Button';

const Container = styled(Flex)({
  background: 'linear-gradient(352.23deg, #4BBDAC -15.27%, #016585 98.54%)',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 60,
});

const StyledText = styled(Box)`
  font-style: normal;
  font-weight: 800;
  font-size: 30px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #ffffff;
  padding-bottom: 30px;
  text-align: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_TABLET}) {
    font-weight: 900;
  }
`;

export const JoinOpenLearning = ({
  header,
  buttonText,
  buttonAction,
}: JoinOpenLearningProps): ReactElement => {
  const JoinButton = styled(Button)({
    background: '#FFFFFF',
    color: '#041416',
  });

  return (
    <Container>
      <StyledText>{header}</StyledText>
      <Box>
        <JoinButton action={buttonAction}>{buttonText}</JoinButton>
      </Box>
    </Container>
  );
};
